import { render } from "./CostReport.vue?vue&type=template&id=37b7391f&scoped=true"
import script from "./CostReport.vue?vue&type=script&lang=js"
export * from "./CostReport.vue?vue&type=script&lang=js"

import "./CostReport.vue?vue&type=style&index=0&id=37b7391f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b7391f"]])

export default __exports__